import type { PaginationMeta } from 'common/types';

export type StripeFields = {
  stripeId: string | null;
  isStripeLinked: boolean;
  stripeStatus: string | null;
};

export type StripeConnection = {
  connectionType: 'individual' | 'pooled' | 'none';
  isLinked: boolean;
  stripe: StripeFields;
  employerStripe?: StripeFields;
};

export type EmployerRef = { objectId: string; name: string };

export type UserDto = {
  objectId: string;
  username: string | null;
  firstname: string | null;
  lastname: string | null;
  jobTitle: string | null;
  phone: string | null;
  email: string | null;
  level: number | null;
  createdAt: string;
  updatedAt: string;
};

export type WorkerDto = {
  objectId: string | null;
  workerPrivateId: string | null;
  displayname: string | null;
  firstname: string | null;
  lastname: string | null;
  jobTitle: string | null;
  email: string | null;
  phone: string | null;
  employeeId: string | null;
};

export type TeamRecordType = 'individual' | 'pooled' | 'admin' | 'super-admin';

export type TeamRecord = {
  recordType: TeamRecordType;
  employer: EmployerRef;
  user: UserDto | null;
  worker: WorkerDto | null;
  stripeConnection: StripeConnection;
  managementRole?: string;
  createdAt: string;
};

export type EmployerTeamSearchBy = {
  firstName?: string;
  lastName?: string;
  username?: string;
  employerName?: string;
  recordType?: '' | TeamRecordType;
  status?: '' | 'linked' | 'unlinked' | 'individual' | 'pooled';
  connectionType?: '' | 'individual' | 'pooled';
};

export type EmployerTeamRecordsMeta = PaginationMeta & {
  employerIds: string[];
};

export type EmployerTeamRecordsResponse = {
  users: TeamRecord[];
  roleMap: Record<string, string[]>;
  meta: EmployerTeamRecordsMeta;
};

export type GetEmployerTeamRecordsParams = {
  pageNumber?: number;
  pageSize?: number;
  employerIds?: string[];
  includeRoles?: ('admin' | 'super-admin')[];
  searchBy?: EmployerTeamSearchBy;
};

/** Fetch entire team list in one request; client filters/pages locally. */
export const EMPLOYER_TEAM_ALL_RECORDS_PAGE_SIZE = 999999;

export type EmployerTeamStripeStatusTableProps = {
  employerIds?: string[];
  defaultPageSize?: number;
  showManagementAccounts?: boolean;
  onRecordClick?: (record: TeamRecord) => void;
  onSendOnboardingReminder?: (record: TeamRecord) => void;
};
